import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import axios from "../../services/api/api";
import { AUTH_BASE_URL } from "../../constants/api.constants";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { copyToClipboard } from "../../Utilities/clipboardHelper";
import {
  PASSWORD_PATTERN,
  generatePassword,
} from "../../Utilities/passwordPolicy";

// Byter lösenord på ett Analytics-tjänstekonto. De kontona har ingen brevlåda, så det
// vanliga återställningsmailet når dem aldrig. Anropet går till auth-serverns
// updateanalyticspassword, som kräver admin-token och bara accepterar Analytics-konton.
export default function ChangeAnalyticsPasswordModal({ isOpen, toggle, user }) {
  const intl = useIntl();
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setPassword("");
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const isValid = PASSWORD_PATTERN.test(password);

  const submit = () => {
    setIsSubmitting(true);

    // Absolut url gör att baseURL för LWC-API:t inte används, medan instansens
    // interceptor fortfarande lägger på bearer-token som endpointen kräver.
    axios
      .post(`${AUTH_BASE_URL}/token/updateanalyticspassword`, {
        email: user.email,
        newPassword: password,
      })
      .then((res) => {
        if (res.data?.code === "999") {
          toast.success(
            <FormattedMessage id="AnalyticsPasswordChanged" />,
            TOAST_CONFIG,
          );
          toggle();
        } else {
          toast.warn(
            res.data?.message ??
              intl.formatMessage({ id: "AnalyticsPasswordChangeFailed" }),
            TOAST_CONFIG,
          );
          setIsSubmitting(false);
        }
      })
      .catch(() => {
        toast.warn(
          <FormattedMessage id="AnalyticsPasswordChangeFailed" />,
          TOAST_CONFIG,
        );
        setIsSubmitting(false);
      });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <FormattedMessage id="ChangePassword" />
      </ModalHeader>
      <ModalBody>
        <p>{user?.email}</p>
        <FormGroup>
          <Label>
            <FormattedMessage id="Password" />
          </Label>
          <div className="d-flex gap-2">
            <Input
              type="text"
              autoComplete="off"
              value={password}
              invalid={password.length > 0 && !isValid}
              onChange={(event) => setPassword(event.target.value)}
            />
            <Button
              type="button"
              color="primary"
              outline
              className="text-nowrap flex-shrink-0"
              onClick={() => setPassword(generatePassword())}
            >
              <FormattedMessage id="GeneratePassword" />
            </Button>
            <Button
              type="button"
              color="primary"
              outline
              className="flex-shrink-0"
              disabled={!password}
              title={intl.formatMessage({ id: "Copy" })}
              onClick={() => copyToClipboard(password, intl)}
            >
              <FontAwesomeIcon icon={faCopy} />
            </Button>
          </div>
          <p className="text-muted small mb-0 mt-1">
            <FormattedMessage id="AnalyticsPasswordHint" />
          </p>
          <p className="text-danger small mb-0 mt-1">
            <FormattedMessage id="AnalyticsPasswordWarning" />
          </p>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          color="primary"
          disabled={!isValid || isSubmitting}
          onClick={submit}
        >
          <FormattedMessage id="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
